import api from './api';

const TOKEN_KEY = 'ggmf_token';
const USER_KEY = 'ggmf_user';

const authService = {
  /**
   * Login com email e password
   * @returns {Promise<{ access_token: string, user: object }>}
   */
  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    const { access_token, user } = response.data;
    localStorage.setItem(TOKEN_KEY, access_token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    return response.data;
  },

  /**
   * Solicitar email de recuperação de senha
   * @returns {Promise<{ message: string }>}
   */
  async forgotPassword(email) {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  /**
   * Redefinir senha com token recebido por email
   * @returns {Promise<{ message: string }>}
   */
  async resetPassword(token, newPassword) {
    const response = await api.post('/auth/reset-password', { token, newPassword });
    return response.data;
  },

  /**
   * Terminar sessão
   */
  logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },

  /**
   * @returns {string|null} JWT token
   */
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * @returns {object|null} dados do utilizador autenticado
   */
  getUser() {
    const user = localStorage.getItem(USER_KEY);
    return user ? JSON.parse(user) : null;
  },

  /**
   * @returns {boolean}
   */
  isAuthenticated() {
    return !!this.getToken();
  },
};

export default authService;
